<template>
  <div>
    <div v-if="!libraryAssociationResponse && isActive">
      <PreAssociation />
    </div>

    <div v-if="libraryAssociationResponse">
      <PostAssociation @next="$emit('next')" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import PreAssociation from "./LibraryAssociation/PreAssociation.vue"
import PostAssociation from "./LibraryAssociation/PostAssociation.vue"

export default {
  name: "LibraryAssociation",

  props: ["isActive"],

  components: {
    PreAssociation,
    PostAssociation
  },

  computed: {
    ...mapGetters(["libraryAssociationResponse"])
  }
}
</script>
